<template>
  <div
    v-if="visible"
    class="pending-banner"
    :class="`pending-banner--${variant}`"
    role="alert"
  >
    <span class="pending-banner-icon">
      <ExclamationIcon />
    </span>

    <p class="pending-banner-text">{{ message }}</p>

    <button
      type="button"
      class="pending-banner-action"
      @click="$emit('view')"
    >
      Ver notificações
    </button>

    <button
      type="button"
      class="pending-banner-close"
      aria-label="Fechar"
      @click="$emit('dismiss')"
    >
      ×
    </button>
  </div>
</template>

<script>
import ExclamationIcon from "@/components/svg/Exclamation.vue";

export default {
  name: "PendingNotificationsBanner",

  components: { ExclamationIcon },

  props: {
    variant: {
      type: String,
      default: "warning",
      validator: (value) => ["danger", "warning", "info"].includes(value),
    },
    count: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    visible() {
      return this.count > 0;
    },

    message() {
      const noun = this.count === 1 ? "notificação" : "notificações";

      if (this.variant === "danger") {
        return `Você tem ${this.count} ${noun} vencida${
          this.count === 1 ? "" : "s"
        }.`;
      }

      if (this.variant === "warning") {
        return `Você tem ${this.count} ${noun} próxima${
          this.count === 1 ? "" : "s"
        } do prazo.`;
      }

      return `Você tem ${this.count} ${noun} pendente${
        this.count === 1 ? "" : "s"
      }.`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables.scss";

.pending-banner {
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 10px;
color: $white;
  margin-top: 8px;
  margin-bottom: 8px;
  margin-left: auto;
  margin-right: auto;
  max-width: 1350px;
  padding: 12px 16px;
  width: 100%;

  &.pending-banner--danger {
    background: $red;
  }

  &.pending-banner--warning {
    background: $orange2;
  }

  &.pending-banner--info {
    background: $blue;
  }
}

.pending-banner-icon {
  display: inline-flex;
  flex-shrink: 0;

  ::v-deep svg path {
    fill: currentColor;
  }
}

.pending-banner-text {
  color: $white;
  flex: 1 1 auto;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.4;
  margin: 0;
}

.pending-banner-action {
  background: $white;
  border: none;
  border-radius: 5px;
  color: $orange2;
  cursor: pointer;
  flex-shrink: 0;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  padding: 6px 14px;

  .pending-banner--danger & {
    color: $red;
  }

  .pending-banner--info & {
    color: $blue;
  }

  &:hover {
    filter: brightness(0.95);
  }
}

.pending-banner-close {
  background: transparent;
  border: none;
  color: $white;
  cursor: pointer;
  flex-shrink: 0;
  font-size: 24px;
  line-height: 1;
  opacity: 0.8;
  padding: 0 4px;

  &:hover {
    opacity: 1;
  }
}
</style>
